import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import {
  isProductionEnvironmentBanner,
  pickApiEnvironmentName,
  resolveEnvironmentBannerLabel
} from '../shared/api-environment-banner';

@Injectable({ providedIn: 'root' })
export class ApiEnvironmentBannerService {
  private banner$: Observable<string | null>;

  constructor(private http: HttpClient) {
    this.banner$ = this.http.get<unknown>(`${environment.apiurl}system/environment`).pipe(
      map((payload) =>
        resolveEnvironmentBannerLabel(pickApiEnvironmentName(payload), environment.production)
      ),
      catchError(() => of(null)),
      shareReplay(1)
    );
  }

  getBannerLabel(): Observable<string | null> {
    return this.banner$;
  }

  isProductionBanner(label: string | null): boolean {
    return isProductionEnvironmentBanner(label);
  }
}
